// Changes XML to JSON
function xmlToJson(xml) {
									
    // Create the return object
    var obj = {};

    if (xml.nodeType == 1) { // element
        // do attributes
        if (xml.attributes.length > 0) {
        obj["_attributes"] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
                var attribute = xml.attributes.item(j);
                obj["_attributes"][attribute.nodeName] = attribute.nodeValue;
            }
        }
    } else if (xml.nodeType == 3) { // text
        obj = xml.nodeValue;
    }

    // do children
    if (xml.hasChildNodes()) {
        for(var i = 0; i < xml.childNodes.length; i++) {
            var item = xml.childNodes.item(i);
            var nodeName = item.nodeName;
            if (typeof(obj[nodeName]) == "undefined") {
                obj[nodeName] = xmlToJson(item);
            } else {
                if (typeof(obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }
    return obj;
};

var getVacancies = function(){
    fetch("https://hmc.easycruit.com/export/xml/vacancy/list.xml")
        .then(function(response) {
            response.text()
                .then(function(data){
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(data,"text/xml");
                    const jsonObj = xmlToJson(xmlDoc);
                    new Vacancies(jsonObj);
                })
        })
        .catch(function(error) {console.error(`Fetch Error =\n`, error)});
}

var getVacancy = function(id, departmentId){
    fetch("https://hmc.easycruit.com/export/xml/vacancy/"+id+".xml")
        .then(function(response) {
            response.text()
                .then(function(data){
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(data,"text/xml");
                    const jsonObj = xmlToJson(xmlDoc);
                    new Vacancy(jsonObj, departmentId);
                })
        })
        .catch(function(error) {console.error(`Fetch Error =\n`, error)});
}

var updateModal = function(title, bodyText, url){
    document.querySelector('#vacancyModal .modal-title').innerText = title;
    document.querySelector('#vacancyModal .modal-body').innerHTML = bodyText;
    document.querySelector('#solicitatieLink').href = url;
}

function toObject(arr) {
    var rv = {};
    for (var i = 0; i < arr.length; ++i)
        rv[i] = arr[i];
    return rv;
}

// jQuery way of native extention definition
Object.defineProperty(Object.prototype, 'isEmpty',{
    value : function() {
        for(var key in this) {
            if(this.hasOwnProperty(key))
                return false;
        }
        return true;
    },
    enumerable : false
  });
// Object.prototype.isEmpty = function() {
//     for(var key in this) {
//         if(this.hasOwnProperty(key))
//             return false;
//     }
//     return true;
// }

class Vacancies{
    constructor(vacanciesObj){
        this.vacanciesContainer = document.querySelector('#hmcVacanciesList');
        const vacancyList = vacanciesObj.VacancyList;

        // check if is array and has items or check if object is not empty
        if(vacancyList.Vacancy){
            for( const key in vacancyList){
                if (vacancyList.hasOwnProperty(key) && key === 'Vacancy') {
                    if(vacancyList[key].constructor === Array){
                        // console.log('is een array');
                        vacancyList[key].forEach(item => {
                            this.createVacancyAndAddToList(item);
                        })
                    } else {
                        // console.log('is geen array');
                        this.createVacancyAndAddToList(vacancyList[key]);
                    }
                }
            }
        } else {
            // show if no vacancies available text
            const emptyMessage = document.createElement('li');
            emptyMessage.classList.add('list-group-item');
            emptyMessage.innerText = 'Er zijn momenteel geen vacatures beschikbaar.';
            this.vacanciesContainer.append(emptyMessage);
        }
    }

    createVacancyAndAddToList(vacancy){
        const vacancyID = vacancy._attributes.id;

        const vacancyElement = document.createElement('li');
        vacancyElement.classList.add('vacancy-item');
        vacancyElement.classList.add('list-group-item');
        vacancyElement.id = 'vacancy_'+vacancyID;
        
        const vacancyTitleElement = document.createElement('span');
        vacancyTitleElement.classList.add('title');
        vacancyTitleElement.innerText = vacancy.Versions.Version.Title['#text'];
        
        const vacancyDepartmentsElement = document.createElement('div');
        vacancyDepartmentsElement.classList.add('departments');

        let vacancyDepartmentElement,
        vacancyNameElement,
        vacancyLinkElement,
        currentVacancyID
        
        if(vacancy.Departments.Department[0]){
            vacancy.Departments.Department.forEach(department => {
                vacancyDepartmentElement = document.createElement('div');
                vacancyDepartmentElement.classList.add('department');
                
                vacancyNameElement = document.createElement('span');
                vacancyNameElement.classList.add('name');
                vacancyNameElement.innerText = department.Name['#text'];

                currentVacancyID = 'vac_'+vacancyID+'_'+department._attributes.id;

                vacancyLinkElement = document.createElement('a');
                vacancyLinkElement.classList.add('modal-link');
                vacancyLinkElement.innerText = 'Bekijk vacature';
                vacancyLinkElement.href = 'javascript:void(0)';
                vacancyLinkElement.setAttribute("data-toggle", "modal");
                vacancyLinkElement.setAttribute("data-target", "#vacancyModal");
                vacancyLinkElement.setAttribute("data-department-id", currentVacancyID);
                
                vacancyLinkElement.addEventListener('click', (event)=>{
                    const currentModalVacancyId = document.querySelector('#vacancyModal').getAttribute('data-vacature-id');
                    const currentTargetDepartmentId = event.target.getAttribute('data-department-id')


                    document.querySelector('#vacancyModal').setAttribute('data-vacature-id',currentTargetDepartmentId);
                    if( currentModalVacancyId != currentTargetDepartmentId){
                        updateModal('','','')
                        getVacancy(vacancyID, department._attributes.id)
                    }
                });

                vacancyDepartmentElement.append(vacancyNameElement);
                vacancyDepartmentElement.append(vacancyLinkElement);
                vacancyDepartmentsElement.append(vacancyDepartmentElement);
            })
        } else {
            vacancyDepartmentElement = document.createElement('div');
            vacancyDepartmentElement.classList.add('department');
            
            vacancyNameElement = document.createElement('span');
            vacancyNameElement.classList.add('name');
            vacancyNameElement.innerText = vacancy.Departments.Department.Name['#text'];

            vacancyLinkElement = document.createElement('a');
            vacancyLinkElement.classList.add('modal-link');
            vacancyLinkElement.innerText = 'Bekijk vacature';
            vacancyLinkElement.href = 'javascript:void(0)';
            vacancyLinkElement.setAttribute("data-toggle", "modal");
            vacancyLinkElement.setAttribute("data-target", "#vacancyModal");

            currentVacancyID = 'vac_'+vacancyID;
        
            vacancyLinkElement.addEventListener('click', function(){
                const currentModalVacancyId = document.querySelector('#vacancyModal').getAttribute('data-vacature-id');

                document.querySelector('#vacancyModal').setAttribute('data-vacature-id',currentVacancyID);
                if( currentModalVacancyId != currentVacancyID){
                    updateModal('','','')
                    getVacancy(vacancyID)
                }
            });

            vacancyDepartmentElement.append(vacancyNameElement);
            vacancyDepartmentElement.append(vacancyLinkElement);
            vacancyDepartmentsElement.append(vacancyDepartmentElement);
        }

        vacancyElement.append(vacancyTitleElement);
        vacancyElement.append(vacancyDepartmentsElement);
        this.vacanciesContainer.append(vacancyElement);
    }
}

class Vacancy{
    constructor(vacancyDetail, departmentId){
        const title = vacancyDetail.Vacancy.Versions.Version.TitleHeading['#text'];
        const bodyText = vacancyDetail.Vacancy.Versions.Version.Description['#text'];
        let url = ''
        if(vacancyDetail.Vacancy.Departments.Department[0]){
            url = vacancyDetail.Vacancy.Departments.Department.filter(department => department._attributes.id === departmentId)[0].VacancyURL['#text']
        } else {
            url = vacancyDetail.Vacancy.Departments.Department.VacancyURL['#text'];
        }
        
        updateModal(title, bodyText, url)
    }
}
